import React from 'react'


const RadioButtonItem = props => {

	const {
		label,
		name,
		value
	} = props

	function radioHandler(event) {

		var i, currentItem, radioItem

		currentItem = event.currentTarget
		radioItem = document.getElementsByClassName(currentItem.className)

		for (i = 0; i < radioItem.length; i++) {
			radioItem[i].parentNode.className = radioItem[i].parentNode.className.replace(" _selected", "")
		}

		currentItem.parentNode.className += " _selected"

		props.onClick && props.onClick(currentItem.value, label)

	}

	return (
		<label>
			<input
				type="radio"
				className={name}
				name={name}
				value={value}
				onClick={event => radioHandler(event)}
			/>
			<span>{label}</span>
		</label>
	)

}


export default RadioButtonItem
